import React, { useEffect } from "react"
import { TableBody, TableRow, TableHead, Stack } from "@mui/material"
import { packagingNature } from "../../../utils/packaging"
import { StyledTable, StyledBodyCell, StyledHeaderCell } from "../../../components/styled/StyledTableComponents"
import Typography from "@mui/material/Typography"
import { COLORS } from "../../../utils"

const PackagingExecutionPackagings = ({ packagings = [], expectedPackagingNumber = 0, packagingForecastNumber = 0, setFieldValue }) => {

	const _updatePackagingForecastNumber = (packagings, packagingForecastNumber) => {
		if (packagings.length === 1) {
			setFieldValue("packagings[0].forecastNumber", packagingForecastNumber)
			return
		}
		let currentPackagingForecastNumber = packagingForecastNumber
		for (const packaging of packagings) {
			const index = packagings.indexOf(packaging)
			const isLast = index === packagings.length - 1
			const packagingTheoreticalNumber = packaging.theoreticalNumber || 0
			const usedPackagingNumber = isLast ? currentPackagingForecastNumber : Math.min(packagingTheoreticalNumber, currentPackagingForecastNumber)
			setFieldValue(`packagings[${index}].forecastNumber`, usedPackagingNumber)
			currentPackagingForecastNumber -= usedPackagingNumber
			currentPackagingForecastNumber = Math.max(0, currentPackagingForecastNumber)
		}
	}

	useEffect(() => {
		_updatePackagingForecastNumber(packagings, packagingForecastNumber)
	}, [packagings, packagingForecastNumber])

	return (
    <Stack spacing={2} sx={{width:"100%"}}>

      <Stack spacing={1} direction={"row"}>
        <img src="/img/packagingExecutions/packagingNumber.svg" alt="Packaging Icon" />
        <Typography variant="h6" sx={{fontSize: "14px", lineHeight: "22px", color: COLORS.BLACK800}}>
          Nombre de barquettes
        </Typography>
      </Stack>

      <StyledTable>
        <TableHead>
          <TableRow>
            <StyledHeaderCell>Estimation</StyledHeaderCell>
              {packagings.map((currentPackaging, index) => (
                <React.Fragment key={index}>
                  <StyledHeaderCell>
                    {packagingNature.find((p) => p.value === currentPackaging.type)?.label}
                  </StyledHeaderCell>
                </React.Fragment>
              ))}
            <StyledHeaderCell>Total</StyledHeaderCell>
          </TableRow>
        </TableHead>

        <TableBody>
          <TableRow>
            <StyledBodyCell leftEdge={true}>Théorique</StyledBodyCell>
              {packagings.map((currentPackaging, index) => (
                <React.Fragment key={index}>
                  <StyledBodyCell>
                    {Math.round(currentPackaging.theoreticalNumber * 100) / 100 || "-"}
                  </StyledBodyCell>
                </React.Fragment>
              ))}
            <StyledBodyCell rightEdge={true}>
              {Math.round(expectedPackagingNumber * 100) /100 || "-"}
            </StyledBodyCell>
          </TableRow>
          <TableRow>
            <StyledBodyCell leftEdge={true} lastTableRow={true}>Prévisionnelle</StyledBodyCell>
              {packagings.map((currentPackaging, index) => (
                <React.Fragment key={index}>
                  <StyledBodyCell>
                    {Math.round(currentPackaging.forecastNumber * 100) / 100|| "-"}
                  </StyledBodyCell>
                </React.Fragment>
              ))}
            <StyledBodyCell rightEdge={true} lastTableRow={true}>
              {packagingForecastNumber || "-"}
            </StyledBodyCell>
          </TableRow>
        </TableBody>
      </StyledTable>
    </Stack>
	)
}

export default PackagingExecutionPackagings
